import { ref, computed, watch } from '@vue/composition-api'
import { getDatasetModule } from '../config/datasets'

const FREQ_PRESETS = [
  { label: '15s', value: '15s' },
  { label: '1 min', value: '1m' },
  { label: '1 hora', value: '1h' },
  { label: '1 día', value: '1d' },
  { label: '1 sem', value: '1w' },
  { label: '2 semanas', value: '2w' },
  { label: '1 mes', value: '1mo' },
  { label: '3 meses', value: '3mo' },
  { label: '6 meses', value: '6mo' },
  { label: '1 año', value: '1y' },
  { label: '3 años', value: '3y' },
  { label: 'Día sem.', value: 'wd_name_short' },
  { label: 'Día semana', value: 'wd_name' },
  { label: 'Día (numero)', value: 'd_str' },
  { label: 'Mes (abrev.)', value: 'mo_name_short' },
  { label: 'Mes (nombre)', value: 'mo_name' },
  { label: 'Año', value: 'y_str' },
]

/**
 * Composable for date grouping (freq) selection.
 *
 * Shows frequency presets when the selected field has defaultParams.freq
 * OR when the current view is timeseries.
 *
 * @param {import('@vue/composition-api').Ref<string>} selectedDataset
 * @param {import('@vue/composition-api').Ref<string>} selectedField
 * @param {import('@vue/composition-api').Ref<string>} [selectedView] - current view
 * @returns {{ selectedFreq: Ref<string>, dateGroupingPresets: ComputedRef<Array> }}
 */
export function useChartDateGrouping(selectedDataset, selectedField, selectedView) {
  const selectedFreq = ref('')

  const dateGroupingPresets = computed(() => {
    // Always show presets for timeseries view
    if (selectedView?.value === 'timeseries') return FREQ_PRESETS

    const module = getDatasetModule(selectedDataset.value)
    if (!module || !module.fields) return []
    const fieldDef = module.fields.find(f => f.key === selectedField.value)
    if (!fieldDef || !fieldDef.defaultParams || !fieldDef.defaultParams.freq) return []
    return FREQ_PRESETS
  })

  // Reset freq when dataset or field changes
  watch(selectedDataset, () => { selectedFreq.value = '' })
  watch(selectedField, () => {
    const module = getDatasetModule(selectedDataset.value)
    const fieldDef = module?.fields?.find(f => f.key === selectedField.value)
    selectedFreq.value = fieldDef?.defaultParams?.freq || ''
  })

  return { selectedFreq, dateGroupingPresets }
}
